module.exports = __webpack_public_path__ + "static/media/video-thumbnail.a1271a51.avif";